module.exports = __webpack_public_path__ + "9072e581c5cc658b4be77ec41ffa9830.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/service-icon-shared-hosting.png
// module id = 659
// module chunks = 1